import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Input, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { BondMath } from '../bondmath/bondmath';
import {Observable} from 'rxjs/Rx';
import { TimerComponent } from '../game/timer.component';

import { BondMathComponentService } from '../bondmath/bondmathComponent.service';
import { Subscription }   from 'rxjs/Subscription';


@Component({
  selector: 'bondmath-header',
  templateUrl: './header-bondmath.component.html',
  providers: [TimerComponent, BondMath],
  encapsulation: ViewEncapsulation.None
})
export class HeaderBondMathComponent implements OnInit {

  constructor(public _srvc: BondMathComponentService, private _bondMath: BondMath, private elRef:ElementRef) {
    
  }

  public status:{isopen:boolean} = {isopen: false};
  public start:boolean = false;
  
  @ViewChild('startSwitch') startSwitch;
  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
    console.log('status: ' + this.status.isopen);
  }

  public toggleStart(){
    this.start = !this.start;
    console.log('toggle start', this.start);
    this.startSwitch.nativeElement.checked = this.start;
    this._srvc.SwitchView(this.start);      
  }
  ngOnInit() {
    
  }

  ngOnDestroy() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/header-bondmath.component.ts